import { usePageStore } from '@/store';
import { handleAgent } from '@/common/agents';

export default {
    async getAgentInfo(agentId) {
        const globalData = usePageStore(this.$pinia).page;
        let module = globalData.siteType === 3 || !globalData.isLandingPage ?  ',module:"footer"' : '';
        let res = await this.axiosIns.post('/api-graphql', {
            query: `{agent(id:${agentId}${module}){firstName,lastName,image,headUrl:image,headShots{photoFiveByThree,photoOneByOne,photoThreeByFour},fullName,phone,email,position,license,agentSocialNetworks{id,url,socialNetwork},disclaimerList{fileName, queryLink},address,officeAddress}}`
        });
        let agent = { ...res.data?.agent };
        this.agents[agentId] = handleAgent(agent);
    },
    async getGroupName() {
        const pageStore = usePageStore(this.$pinia);
        let page = pageStore.page || {};
        let ownerId = page?.agentCreator?.userId;
        let { data: list } = await this.axiosIns(`/open-api/ogr/structure/superstratum?ownerId=${ownerId}`)
        if (list?.length) {
            let { name = '' } = list.pop()
            return name
        } 
    },
    // GET_COMPANYNAMEBYID
    getCompanyNameById(id = '', teamId) {
        return this.axiosIns.get('/open-api/ogr/structure/getNameById', {
            params: {
                orgId: id,
                teamId: teamId
            }
        }).then(res => {
            return res.data || '';
        });
    },
    // GET_SUBDOMAIN_AGENTS
    getSubdomainAgents() {
        return this.axiosIns.get('/api-site/getAgentList').then(res => {
            const data = res?.data?.length
                ? res.data.map(agent => {
                    agent.disclaimerList = agent.disclaimerList.map(
                        ({ fileName = '', queryLink = '' }) => ({
                            url: queryLink,
                            name: fileName
                        })
                    );
                    return agent;
                })
                : [];
            this.subdomainAgents = data;
        })
    },
    getCompanyInfo() {
        if (!this.companyPs) {
            this.companyPs = this.axiosIns
                .post('/api-graphql', { query: `{company{name,address}}` })
                .then(({ data = {} }) => {
                    this.defaultCompanyName = data.company?.name || '';
                    return this.companyInfo = data.company || {};
                });
        }
        return this.companyPs;
    },
}